/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var ButtonGroupOrientation = /*@__PURE__*/ (function (ButtonGroupOrientation) {
    ButtonGroupOrientation[ButtonGroupOrientation["Horizontal"] = 0] = "Horizontal";
    ButtonGroupOrientation[ButtonGroupOrientation["Vertical"] = 1] = "Vertical";
    return ButtonGroupOrientation;
})({});
/**
 * @hidden
 */
export var ButtonGroupOrientation_$type = /*@__PURE__*/ markEnum('ButtonGroupOrientation', 'Horizontal,0|Vertical,1');
//# sourceMappingURL=ButtonGroupOrientation.js.map
